import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { spreadByBreakpoints } from './media-spread';
import { sizes } from '../breakpoints';
export var combineByBreakpoints = function combineByBreakpoints(props, modifyFn) {
  var values = props.map(function (value) {
    return spreadByBreakpoints(value, true);
  });
  return sizes.reduce(function (acc, size) {
    var _objectSpread2;

    return _objectSpread(_objectSpread({}, acc), {}, (_objectSpread2 = {}, _objectSpread2[size] = modifyFn(values.map(function (value) {
      return value[size];
    })), _objectSpread2));
  }, {});
};